// extracted by mini-css-extract-plugin
export default {"contentCard":"CardFunction_contentCard__GK2Td"};